import Centrifuge from 'centrifuge'
import Cookie from 'js-cookie'
import config from '../../../config'
import store from '../../store/store'

class WebSocketService {
  constructor () {
    // Singleton
    if (typeof WebSocketService.instance === 'object') {
      return WebSocketService.instance
    }
    const wsURL = config.WS_API_BASE_URL
    const endpointURL = `${config.HTTP_API_BASE_URL}company/${store.getters.authUserCompany.slug}/live/subscribe`
    const subscribeHeaders = {
      'Accept': 'application/json',
      'X-XSRF-TOKEN': decodeURIComponent(Cookie.get('XSRF-TOKEN'))
    }
    if (config.SECRET_HEADER_KEY && config.SECRET_HEADER_VALUE) {
      subscribeHeaders[config.SECRET_HEADER_KEY] = config.SECRET_HEADER_VALUE
    }
    this.socket = new Centrifuge(wsURL, {
      subscribeEndpoint: endpointURL,
      subscribeHeaders
    })

    this.socket.setToken(store.getters.liveToken)

    WebSocketService.instance = this
  }
}

export default WebSocketService
